import React from 'react';
import { node } from 'prop-types';

import { Wrappers, ErrorCard } from '../components';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    // Update state so the next render will show the fallback UI.
    return { hasError: true };
  }

  // componentDidCatch(error, errorInfo) {
  //   // You can also log the error to an error reporting service
  //   logErrorToMyService(error, errorInfo);
  // }

  render() {
    const { hasError } = this.state;
    const { children } = this.props;

    // fallback UI for errors
    if (hasError) {
      return (
        <Wrappers.Layout>
          <ErrorCard
            title="We’re sorry"
            description="An error occurred on our side. You may need to try again later."
          />
        </Wrappers.Layout>
      );
    }

    return children;
  }
}

ErrorBoundary.propTypes = {
  children: node.isRequired
};

export default ErrorBoundary;



// WEBPACK FOOTER //
// ./src/components/ErrorBoundary.js